import { BotaoVoltar } from "@/shared/components/BotaoVoltar";
import { useEffect, useState } from "react";
import { Button } from "@/shared/components/Button";
import { Input } from "@/shared/components/Input";
import { Modal } from "@/shared/components/Modal";
import { useRegistrarVisita } from "@/modules/visitantes/hooks/useVisitantes";
import { hojeSaoPaulo } from "@/modules/visitantes/utils/regras";

interface Props {
  visitante: { id: string; nome: string } | null;
  onClose: () => void;
  onRegistrada: (nome: string) => void;
}

/** "Nova visita": a pessoa voltou — registra mais uma data no histórico dela. */
export function ModalNovaVisita({ visitante, onClose, onRegistrada }: Props) {
  const registrar = useRegistrarVisita();
  const [data, setData] = useState(hojeSaoPaulo());
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    if (visitante) {
      setData(hojeSaoPaulo());
      setErro(null);
    }
  }, [visitante]);

  async function confirmar() {
    if (!visitante) return;
    setErro(null);
    if (!data || data > hojeSaoPaulo()) {
      setErro("Data da visita inválida.");
      return;
    }
    try {
      await registrar.mutateAsync({ id: visitante.id, data });
      onRegistrada(visitante.nome);
      onClose();
    } catch (e) {
      setErro(e instanceof Error ? e.message : "Não foi possível registrar a visita.");
    }
  }

  return (
    <Modal
      titulo="Nova visita"
      aberto={!!visitante}
      onClose={onClose}
      alterado={data !== hojeSaoPaulo()}
    >
      <p className="mb-4 text-sm text-muted">
        {visitante?.nome} voltou? Registre a data para manter o histórico de visitas.
      </p>
      <Input
        label="Data da visita"
        name="dataNovaVisita"
        type="date"
        max={hojeSaoPaulo()}
        value={data}
        onChange={(e) => setData(e.target.value)}
      />
      {erro && (
        <p role="alert" className="mt-3 rounded-md bg-danger/10 px-4 py-3 text-sm text-danger">
          {erro}
        </p>
      )}
      <div className="mt-5 flex justify-end gap-2">
        <BotaoVoltar onClick={onClose} className="min-h-11" />
        <Button
          type="button"
          onClick={confirmar}
          carregando={registrar.isPending}
          className="min-h-11"
        >
          Registrar visita
        </Button>
      </div>
    </Modal>
  );
}
